<script setup>
import { ref } from "vue"
import { KNOLIA } from "@/knolia"
import { defineEmits, defineProps } from "vue"
import CommentBalloon from "./CommentBalloon.vue"

const props = defineProps(["comments", "element"])
const emits = defineEmits(["get-content"])

let textAreaMessage = ref('');
let commentReply = ref([])

function ControlReply(comment = []) {
  commentReply.value = comment
}

async function SendMessage() {
  if(textAreaMessage.value.value == '')
    return 
  
  await KNOLIA.CallBackEnd("post", "set-operations&get=send-comment", {
    comment: textAreaMessage.value.value,
    replied_to: commentReply.value.comment_id,
    element: props.element
  }).then((res) => {
    textAreaMessage.value.value = ''
    commentReply.value = []
    if(res.data.skills_ratings_id)
      Object.assign(props.element, {skills_ratings_id: res.data.skills_ratings_id})

      Object.assign(props.element, {has_comments: true})
    emits('get-content')
  });
}

async function DeleteComment(commentId) {
  await KNOLIA.CallBackEnd("post", "set-operations&get=delete-comment", {
    commentId
  }).then(() => {
    emits('get-content')
  });
}

function GoToComment(id) {
  const comment = document.getElementById(`comment${id}`)
  comment.scrollIntoView()
  comment.classList.add('replied-message')
}

</script>

<template>
  <div class="div-comment-area">
    <div class="div-comment-container scrollbar">
      <CommentBalloon :comment="comment" :reply="false" v-for="comment in props.comments" :key="comment.comment_id"
        @control-reply="ControlReply($event)" @delete-comment="DeleteComment($event)">
        <CommentBalloon :comment="comment.replied_comment" :replied_comment="true" v-if="Object.keys(comment.replied_comment).length > 0" @click="GoToComment(comment.replied_to)"/>
      </CommentBalloon>
    </div>
    <div class="div-send-message-space">
      <div class="reply-comment" v-if="Object.keys(commentReply).length > 0">
        <CommentBalloon :comment="commentReply" :reply="true" @control-reply="ControlReply($event)"/>
      </div>
      <div class="div-send-message">
        <input type="text" ref="textAreaMessage" class="textarea-comment" />
        <button @click="SendMessage()" class="button-send-comment">Enviar</button>
      </div>
    </div>
  </div>
</template>

<style scoped>

.div-comment-container {
  padding: 10px;
  background-color: #060714e6;
  height: 400px;
  box-shadow: inset 0px -1px 13px 4px rgb(0 0 0 / 11%);
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  color: black;
}

.div-comment-container > section:nth-child(n + 2) {
  margin-top: 5px;
}

.div-send-message-space {
  margin: 10px 0;
}

.div-send-message {
  display: flex;
  justify-content: space-between;
  padding: 0px 10px 10px;
  gap: 10px;
}

.textarea-comment {
  flex: 5;
}

.reply-comment {
  padding-left: 15px;
}

.reply-comment section{
  margin-bottom: 10px;
}

.button-send-comment {
  flex: 1;
  line-height: 4px;
}
</style>
